<template>
  <div class="relative flex flex-col justify-start items-center h-full">
    <div class="w-full h-1/6 lg:h-1/10"></div>
    <section-title titlePath="title-9.png" />
    <div class="btns flex flex-row justify-center w-full mb-5">
      <div
        v-for="(menu, index) in menuData"
        :key="index"
        :class="{ menuActive: menu.isActive }"
        class="cursor-pointer w-226 h-78 m-3 text-white font-elmessiri text-xl flex justify-center items-center bg-auto bg-btn bg-10-10 hover:bg-10-108"
        @click="handleMenu(index)"
      >
        {{ menu.text }}
      </div>
    </div>
    <transition-group
      name="fade"
      tag="div"
      class="relative w-full h-560 flex justify-center items-start"
    >
      <div
        v-show="menuData[0].isActive"
        class="absolute w-full max-w-790 flex flex-col justify-center items-center z-20 lg:max-w-538"
        :key="menuData[0].text"
      >
        <img :src="`${imgPath}/slide10/img_pets.png`" />
        <p class="w-full max-w-632 text-center font-nunito text-grayish-orange">
          Pets give you special abilities and skills such as auto-potions and
          auto-loot. Collect them all to create your own La Tale pet family!
          Pets can be acquired through various events, flash sales, premium
          boxes and bonuses.
        </p>
      </div>
      <div
        v-show="menuData[1].isActive"
        class="absolute w-full max-w-790 flex flex-col justify-center items-center z-20 lg:max-w-538"
        :key="menuData[1].text"
      >
        <div class="w-full flex justify-center items-center mt-6">
          <img :src="`${imgPath}/slide10/mounts.png`" />
        </div>
        <p class="w-full max-w-632 text-center font-nunito text-grayish-orange">
          Mounts give you an immense amount of movement speed and jump speed.
          Collect them to show others that you hate walking!
        </p>
      </div>
    </transition-group>
    <img
      class="kitty absolute bottom-60 left-28 h-auto invisible"
      :src="`${imgPath}/slide10/patchworkkitty.png`"
    />
    <img
      class="bear absolute bottom-72 right-6 h-auto z-10 invisible"
      :src="`${imgPath}/slide10/patchworkbear.png`"
    />
    <img
      class="bunny absolute bottom-60 right-40 h-auto invisible"
      :src="`${imgPath}/slide10/patchworkbunny.png`"
    />
  </div>
</template>

<script>
import breakpoints from '@/plugins/breakpoints';
import SectionTitle from '../components/SectionTitle/SectionTitle';
export default {
  components: {
    SectionTitle,
  },
  data: function() {
    return {
      breakpoints,
      imgPath: process.env.VUE_APP_IMG_URL,
      menuData: [
        {
          text: 'Pets',
          isActive: true,
        },
        {
          text: 'Mounts',
          isActive: false,
        },
      ],
      mountsData: [1, 2, 3],
    };
  },
  methods: {
    handleMenu: function(menuIndex) {
      for (let i = 0; i < this.menuData.length; i++) {
        if (menuIndex === i) {
          this.menuData[i].isActive = true;
        } else {
          this.menuData[i].isActive = false;
        }
      }
    },
    init_companion_animation: function() {
      this.$store.commit('ANIMATION/INIT_COMPANION_SECTION_INNER');
    },
    disable_companion_animation: function() {
      this.$store.commit('ANIMATION/DISABLE_COMPANION_SECTION_INNER');
    },
  },
  created: function() {
    this.unwatch = this.$store.watch(
      (state, getters) => getters.activeSection,
      (newValue, oldValue) => {
        //console.log(`Updating from ${oldValue} to ${newValue}`);
        if (newValue === 9 && this.breakpoints.w > 1366) {
          this.init_companion_animation();
        } else if (newValue != 9 && this.breakpoints.w > 1366) {
          this.disable_companion_animation();
        }
      },
    );
  },
  beforeDestroy() {
    this.unwatch();
  },
};
</script>

<style lang="postcss" scoped>
.btns .menuActive {
  @apply bg-10-108;
}
</style>
